<template>
  <div class="reactive-gift-choice--content" v-if="shouldGiftChoiceBlockBeDisplayed">
    <div class="reactive-gift-choice--content-header">
      <div class="reactive-gift-choice--content-header-wrapper">
        <h2 class="col-12 reactive-gift-choice--content-header-title">{{
            t('gift.selection', { namespace: 'giftSelection' }) }}</h2>
      </div>
    </div>
    <div class="reactive-gift-choice--content-body">
      <adv-cart-gift-list :enable-picker="true"
                          :styling-options="stylingOptions"
                          :gift-choices-filter="filterGiftsWithChoice"></adv-cart-gift-list>
    </div>
  </div>
</template>

<script>
import AdvCartGiftList from './AdvCartGiftList'
import giftChoiceMixin from './mixins/giftChoiceMixin'
export default {
  name: 'AdvGiftChoiceBlock',
  data () {
    return {
      stylingOptions: {
        group: 'col-12 p-3',
        groupRow: 'row row-mlr-0',
        items: 'slick-gift-item',
        groupBlock: 'col-12 gift-select-block',
        itemsBlock: 'slick-checkout-gifts-slider-wrapper',
        groupBlockThumbnailBlock: 'col-3 col-sm-1 gift-select-logo',
        groupBlockThumbnail: 'img-fluid',
        groupBlockDescription: 'col-9 col-sm-11 gift-select-info-text',
        hint: 'col-12'
      }
    }
  },
  components: {
    AdvCartGiftList
  },
  mixins: [giftChoiceMixin]
}
</script>
